// uploadHelper.js
import api from '../../api';

function apiOrigin() {
  const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  return apiUrl.replace(/\/api$/i, '');
}

function mediaOrigin() {
  const media = (process.env.REACT_APP_MEDIA_URL || '').replace(/\/$/, '');
  return media || apiOrigin();
}

function cdnOrigin() {
  return (process.env.REACT_APP_API_URL_VIDS || 'https://api.alchemymix.com').replace(/\/$/, '');
}

/**
 * Turn stored upload paths / partial URLs into a browser-loadable src.
 * Handles: full https URLs, //host, host/path (no scheme), /static/..., relative paths.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';

  if (/^(https?:\/\/|data:|blob:)/i.test(trimmed)) {
    return trimmed;
  }

  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }

  // e.g. api.alchemymix.com/static/narration/foo.jpg (missing https://)
  if (/^[a-z0-9][-a-z0-9.]*\.[a-z]{2,}(\/|:)/i.test(trimmed)) {
    return `https://${trimmed.replace(/^\/+/, '')}`;
  }

  const normalized = trimmed.replace(/^\/+/, '');

  // CDN static assets (same host as api.alchemymix.com)
  if (normalized.startsWith('static/')) {
    return `${cdnOrigin()}/${normalized}`;
  }

  if (normalized.startsWith('channel_media/')) {
    return `${cdnOrigin()}/${normalized}`;
  }

  const base = mediaOrigin();
  if (!base) return trimmed;

  const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${base}${path}`;
}

/** Canonical URL to store after upload or paste. */
export function normalizeMediaUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const resolved = resolveMediaUrl(url);
  return resolved || url.trim();
}

function extractUploadUrl(data) {
  if (!data) return '';
  if (typeof data === 'string') return data;
  const nested = data.data && typeof data.data === 'object' ? data.data : null;
  return (
    data.url
    || data.image_url
    || data.imageUrl
    || data.path
    || data.file_url
    || data.fileUrl
    || data.location
    || nested?.url
    || nested?.image_url
    || ''
  );
}

export async function uploadCompositionImage(file, token) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', 'narration');

  const res = await api.post('/upload_composition_image', formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });

  return normalizeMediaUrl(extractUploadUrl(res.data));
}
